import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';
import { colors } from '../../../style/colors';

interface StyleProps {
  open: boolean;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingTop: 16,
    paddingBottom: 8,
  },
  bar: {
    backgroundColor: colors.secondaryLightGreen,
    color: colors.white,
    width: '100%',
    cursor: 'pointer',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomRightRadius: ({ open }) => (open ? 0 : 8),
    borderBottomLeftRadius: ({ open }) => (open ? 0 : 8),
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 16,
    fontSize: 20,
    fontFamily: 'DM Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    [theme.breakpoints.down('xs')]: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
  content: {
    width: '100%',
    backgroundColor: colors.secondaryLightGreen,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.down('xs')]: {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
  headerLabel: {
    fontFamily: 'DM Sans',
    fontWeight: 700,
    color: colors.darkestGray,
  },
  loadingLabel: {
    width: 200,
    fontFamily: 'DM Sans',
    fontWeight: 700,
    color: colors.darkestGray,
    textAlign: 'center',
    marginTop: -50,
  },
  subTitleLabel: {
    fontFamily: 'DM Sans',
    fontWeight: 400,
    color: colors.darkestGray,
  },
  skeletonHeader: {
    borderRadius: 4,
    width: 290,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  skeleton: {
    borderRadius: 4,
    width: 430,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 324,
    marginTop: -50,
  },
}));
